import React from "react";
import { Card, Box, Grid, Skeleton, Stack } from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

export const NotificationHeroSkeleton = () => (
  <Card
    sx={{
      p: { xs: 3, sm: 4 },
      borderRadius: borderRadiusPx.xl,
      backgroundColor: colors.dashboard.cardBg,
      border: `1px solid ${colors.dashboard.cardBorder}`,
      boxShadow: customShadows.cardFlat,
      mb: 4,
    }}
  >
    <Grid container spacing={3.5} alignItems="center">
      <Grid item xs={12} lg={6}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Skeleton variant="rounded" width={42} height={42} sx={{ borderRadius: borderRadiusPx.lg }} />
            <Box sx={{ width: "70%" }}>
              <Skeleton variant="text" width="80%" height={38} />
              <Skeleton variant="text" width="50%" height={18} />
            </Box>
          </Stack>
          <Skeleton variant="text" width="95%" height={20} />
          <Skeleton variant="text" width="85%" height={20} />
          <Stack direction="row" spacing={1.5}>
            <Skeleton variant="rounded" width={130} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
            <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
          </Stack>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Grid container spacing={2}>
          {[1, 2, 3, 4].map((item) => (
            <Grid item xs={6} sm={3} lg={6} key={item}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: borderRadiusPx.lg,
                  bgcolor: colors.slate[50],
                  border: `1px solid ${colors.slate[200]}`,
                  height: "100%",
                }}
              >
                <Skeleton variant="text" width="60%" height={18} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="40%" height={32} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  </Card>
);

export const NotificationListSkeleton = ({ count = 5 }) => (
  <Stack spacing={2}>
    {Array.from({ length: count }).map((_, index) => (
      <Card
        key={index}
        sx={{
          p: { xs: 2, sm: 2.5 },
          borderRadius: borderRadiusPx.xl,
          backgroundColor: colors.dashboard.cardBg,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          boxShadow: customShadows.cardFlat,
        }}
      >
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="flex-start">
          <Skeleton
            variant="rounded"
            width={44}
            height={44}
            sx={{ borderRadius: borderRadiusPx.lg, flexShrink: 0 }}
          />
          <Box sx={{ flex: 1, width: "100%" }}>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
              <Skeleton variant="rounded" width={100} height={20} sx={{ borderRadius: borderRadiusPx.sm }} />
              <Skeleton variant="text" width={80} height={18} />
            </Stack>
            <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="90%" height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="75%" height={20} sx={{ mb: 1.5 }} />
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Skeleton variant="rounded" width={80} height={20} sx={{ borderRadius: borderRadiusPx.xs }} />
              <Skeleton variant="rounded" width={110} height={30} sx={{ borderRadius: borderRadiusPx.md }} />
            </Stack>
          </Box>
        </Stack>
      </Card>
    ))}
  </Stack>
);

export default NotificationListSkeleton;
